
import defaultsDeep from 'lodash.defaultsdeep';
import {normalizeQuotation} from './quotationNormalizer';


const defaultWorkerIntervention = {
    nextStepAfterThanks: null,
    date_job_start : null,
    is_job_edited: false,
    historySteps: null,
    createUserTodo: false,
    askForNewJobSchedule: false,
    createQuotation: false,
    flashMessage: false,
    showFlashErrorConnectionMessage: false,
    isCompleted: false,
    isQuizzOpen: false,
    isFailtExplainOpen: false,
    isTrasparentActif: false,
    step: 'C1',
    previousSteps: [],
    phoneNumberBureau: "003228281450",
    communication: null,
    extraHeight: null,
    isOpenJob: false,
    isJobOpenByWorker:false,
    note: null,
    buttons: {
        IsWorkerInPlace: null,
        IsNotWorkerInPlace: {
            ReasonSelect: null,
            OtherReason: null //If Other Reason is Selected
        },
        IsClientInPlace: null,
    },
    account: {
        price: 0,
        pieces: 0,
        cash: 0,
        paidByBc: 0,
        total: 0,
    },
    customer: {
        firstname: null,
        lastname: null,
        email: null,
        manyTimesOfClickToSubmit: 1,
        isOkEntry: false,
        default_phone : null
    },
    problem: {
        forgotToGiveTheVoucherCodeToClient: null,
        do_not_want_to_sign: null,
        will_not_pay: null,
        warranty: null,
        doublon: null,
        other: null,
        otherExplain: null
    },
    voucher: {
        pricePolicyHourCalculation: 'byQuarterOfHour',
        clientWillPay: false,
        clientWillPayCheckbox: false,

        workTimeStart: null,
        workTimeEnd: null,
        workTotalTimeInMinutes: null,

        items: [],
        beforeExitSignature: true,
        beforeEntrySignature: false,

        isOkEntry: false,
        isOkExit: false,

        isHomeMoreThanTenYears: true,

        description: "intervention en dépannage Plomberie/chauffage/autre",
        priceOfWork: 0,
        pieces: 0,
        supplement: 0,
        vat_regime: 6,
        total: null,
        vat_to_pay: 0,
        total_vat_incl: 0,

        manyTimesOfClickToSubmit: 1,

        conditions_entry_accepted: false,
        timeStartAccepted: false,
        conditions_exit_accepted: false,
        timeEndAccepted: false,

        entry_signature: null,

        is_entry_signature_empty: true,

        exit_signature: null,
        is_exit_signature_empty: true,

        quarterOfHour: {
            enabledWorkForce: false,
            quantity: 4,
            title: '',
            full_title: '',
            price: 0
        },
        byHour: {
            enabledWorkForce: true,
            quantity: 1,
            title: '',
            full_title: '',
            price: 0
        }

    },

    schedule: {
        comment: null,
    },

    fails: {
        failId: null,
        failExplanation: null
    },

    isOpenDevis: false,
    customerPhoneNumber: null,
    selectedJobOption: null,
    selectedJobSubOption: null,
    raisonOfWorkerAbsence: null,
    otherRaisonAbsence: null,
    stepFormContainer: [],
    stepFormindex: 0,
    rememberCreateQuotation: false,
    activateInputTextExplainOtherProblem: false,
    explanationWhyAmountLowerThanExpected: null,
    isQuotationPending: false,
    pictures : {
        has_picture_of_door : false,
        has_picture_of_sticker: false
    },

    pureContact : {
        isInvoiceSent : false,
        discloseAccepted : false,
        dateTimeOfDisclosure : null,
        disclosedTroughtBouton : null,
    }

};

export function normalizeJob(job) {

    if (job.workerIntervention === null) {

        job.workerIntervention = defaultsDeep({}, defaultWorkerIntervention);

        /**
         * Customer
         */
        job.workerIntervention.customer.firstname = job.customer.firstname;
        job.workerIntervention.customer.lastname  = job.customer.lastname;
        job.workerIntervention.customer.email     = job.customer.email;
        job.workerIntervention.customer.lang      = job.customer.lang;
        job.workerIntervention.customer.default_phone = job.customer.default_phone;

        /**
         * Quotation
         */
        job.workerIntervention.is_job_edited = false;
        job.isCompleted = false;

    } else {

        job.workerIntervention = JSON.parse(job.workerIntervention.dataRaw);
        job.isCompleted = job.workerIntervention.isCompleted;

        job.workerIntervention.customer.firstname = job.customer.firstname;
        job.workerIntervention.customer.lastname = job.customer.lastname;
        job.workerIntervention.customer.lang     = job.customer.lang;
        job.workerIntervention.customer.email    = job.customer.email;
        job.workerIntervention.customer.default_phone = job.customer.default_phone;
        job.workerIntervention.flashErrorMessage = false;
        job.workerIntervention.selectedJobOption = false;
        job.workerIntervention.isTrasparentActif = false;
        job.workerIntervention.createUserTodo = false;
        job.workerIntervention.is_job_edited = false;
        job.workerIntervention.flashMessage = false;
        job.workerIntervention.isOpenJob = false;


        if(typeof(job.workerIntervention.pictures) === "undefined"){
            job.workerIntervention.pictures = {
                has_picture_of_door : false,
                has_picture_of_steaker: false
            };
        }

        if(typeof(job.workerIntervention.voucher.workTimeEnd) === 'object'){
            if(job.workerIntervention.voucher.workTimeEnd !== null){
                job.workerIntervention.voucher.workTimeEnd = new Date(job.workerIntervention.voucher.workTimeEnd.date);
            }
        }

        if(typeof(job.workerIntervention.voucher.workTimeStart) === 'object'){
            if(job.workerIntervention.voucher.workTimeStart !== null) {
                job.workerIntervention.voucher.workTimeStart = new Date(job.workerIntervention.voucher.workTimeStart.date);
            }
        }

        if(job.workerIntervention.pureContact === undefined){
            job.workerIntervention.pureContact = defaultWorkerIntervention.pureContact;
        }

    }

    job.customer.customerAddressIntervention = job.customerAddressIntervention;
    job.customer.isOkEntry = false;
    job.customer.addressSelected = false;

    /**
     * Set Default Quotation
     */
    job.workerIntervention.quote = normalizeQuotation(job.workerIntervention.quote);
    job.workerIntervention.quote.job.customer = job.customer;

    /**
     * Set Default Address
     */
    job.workerIntervention.customer.customerAddressIntervention = job.customerAddressIntervention;
    job.workerIntervention.customer.addressSelected = job.customerAddressIntervention;
    job.workerIntervention.customer.address = job.customer.address;
    job.workerIntervention.customer.id   = job.customer.id;

    return job;
}